<template>
  <div class="container">
    <div id="quizNotCompleted" v-if="Qi<quiz.questions.length">
      <h3 class="my-0 bord" style="font-family: 'Recursive', sans-serif;">Step 2 of 3</h3>
      <h3 class="h2 mt-0">Question {{Qi+1}} of {{quiz.questions.length}}</h3>
      <div class="divider"></div>
      <div class="Ques mt-1">
        <p class="h3"> {{ quiz.questions[Qi].text }}</p>
      </div>
      <div class="optionContainer">
        <button
          class="btn-block option center-align"
          v-for="(response, index) in quiz.questions[Qi].responses"
          @click="selectOption(index)"
          :class="{ 'is-selected': userResponses[Qi] == index, 'is-selected-wrong':userResponses[Qi] == index &&quiz.questions[Qi].responses[index].correct,'is-correct':response.correct&&ansChosen}"
          :key="index"
          :disabled="ansChosen"
        ><div class="center-align">{{response.text}}</div></button>
      </div>
      <div class="progresscontainer">
        <button
          class="button waves-effect waves-light grey btn"
          v-on:click="prev()"
          :disabled="Qi < 1"
          v-if="false"
        >Back</button>

        <!-- next button -->
        <button
          class="button waves-effect waves-light orange lighten-3 btn black-text"
          :class="(userResponses[Qi]==null)?'':'is-active'"
          v-on:click="next()"
          :disabled="Qi>=quiz.questions.length || userResponses[Qi]==null"
        >{{ (userResponses[Qi]==null)?'Next':'Next' }}</button>
      </div>
    </div>
    <div name="QuizCompleted" v-show="Qi>=quiz.questions.length">
       <h3 class="my-0 bord" style="font-family: 'Recursive', sans-serif;">Step 3 of 3</h3>
       <h3 class="h2 my-0" style="font-family: 'Recursive', sans-serif;">Certification</h3>
      <h3 style="font-family: 'Recursive', sans-serif;">You scored:</h3>
      <h5 style="font-family: 'Recursive', sans-serif;">{{getScore()}}/{{quiz.questions.length}}</h5>
      <button class="button waves-effect waves-light black-text orange lighten-3 btn my-5" @click="pdf">Download Certificate</button>
      
    </div>
  </div>
</template>

<script>
var quiz = {
  user: "Temp",
  questions: [
    {
      text: "What causes COVID-19?",
      responses: [
        { text: "Corona virus", correct: true },
        { text: "Adeno virus" },
        { text: "Vibrio choleraC" },
        { text: "Mycobacterium tuberculosis" },
      ],
    },
    {
      text: "What is Eu- stress",
      responses: [
        { text: "Dangerous stress " },
        { text: "Unnecessary stress" },
        { text: "Good stress", correct: true },
        { text: "Altered stress" },
      ],
    },
    {
      text: "This is acute stress",
      responses: [
        { text: "Short- lived stress", correct: true },
        { text: "Painful stress" },
        { text: "Long- time stress" },
        { text: "Hazardous stress" },
      ],
    },
    {
      text: "Solution for rumination of thoughts (repeated thoughts)",
      responses: [
        { text: "To practice being in the present " },
        { text: "To practice yoga" },
        { text: "Watch your breath" },
        { text: "All the above", correct: true },
      ],
    },
    {
      text: "Which hormone increases during stress",
      responses: [
        { text: "Endorphine " },
        { text: "Cortisol", correct: true },
        { text: "Oxytocin" },
        { text: "All the above" },
      ],
    },
    {
      text: "How many limbs are there in yoga",
      responses: [
        { text: "6" },
        { text: "2" },
        { text: "7" },
        { text: "8", correct: true },
      ],
    },
    {
      text: "Kapalbhati is what practice",
      responses: [
        { text: "Slow breathing pranayama" },
        { text: "Meditation"},
        { text: "Tranqutizing pranayama" },
        { text: "Fast breathing pranayama", correct: true  },
      ],
    },
    {
      text: "Which practice helps in improving immunity",
      responses: [
        { text: "Suryanamaskara", correct: true  },
        { text: "Left nostril breath"},
        { text: "Walking" },
        { text: "repeated thinking" },
      ],
    },
    {
      text: "What are the body systems that yoga improves?",
      responses: [
        { text: "Immune system" },
        { text: "Mental health"},
        { text: "Respiratory system" },
        { text: "All of the above", correct: true  },
      ],
    },
    {
      text: "What are yamas-niyamas",
      responses: [
        { text: "Physical postures" },
        { text: "Breathing practices" },
        { text: "Self regulations of disciplines" , correct: true},
        { text: "None of the above" },
      ],
    },
    {
      text: "Which yoga practice involves breath holding",
      responses: [
        { text: "Sectional breathing (Vibhagiya pranayama)", correct: true  },
        { text: "Kapalbhati pranayama"},
        { text: "Nadishuddhi pranayama" },
        { text: "Bhastrika pranayama" },
      ],
    },
    {
      text: "What are the measures to be taken to avoid COVID-19?",
      responses: [
        { text: "Social distancing" },
        { text: "Wearing mask" },
        { text: "Washing hand frequently" },
        { text: "All of the above" , correct: true},
      ],
    },
    {
      text: "Tulsi is also called as",
      responses: [
        { text: "Surasa" , correct: true },
        { text: "Ashwagandha"},
        { text: "Brahmi" },
        { text: "None of the above" },
      ],
    },
    {
      text: "Which is the Kashaya prescribed by central government?",
      responses: [
        { text: "Amruthotharam Kashayam" },
        { text: "Bala Punarnavadi Kashayam" },
        { text: "Ayush Kwatha", correct: true },
        { text: "Jeera kashaya" },
      ],
    },
    {
      text:
        "Which of the following ingredients are used in preparing Ayush Kwatha?",
      responses: [
        { text: "Lemon" },
        { text: "Tulsi" },
        { text: "Pepper" },
        { text: "All of the above", correct: true },
      ],
    },
    {
      text: "What are the uses of pepper?",
      responses: [
        { text: "Reduces fever" },
        { text: "Decreases cough" },
        { text: "Increases immunity" },
        { text: "All of the above", correct: true },
      ],
    },
    {
      text: "How much of Tulsi is added to Ayush Kwatha?",
      responses: [
        { text: "2 Parts" },
        { text: "4 Parts", correct: true },
        { text: "6 Parts" },
        { text: "3 Parts" },
      ],
    },
    {
      text: "What are the common symptoms of COVID-19?",
      responses: [
        { text: "Dry cough" },
        { text: "Difficulty in Breathing" },
        { text: "Nausea" },
        { text: "Both A and B", correct: true },
      ],
    },
    {
      text: "Which is called “Queen of Herbs”?",
      responses: [
        { text: "Pepper", correct: true },
        { text: "Ginger" },
        { text: "Cinamon" },
        { text: "none of the above" },
      ],
    },
    {
      text: "Ayush Kwatha is also called as",
      responses: [
        { text: "Ayush Pudineer" },
        { text: "Ayush Joshanda" },
        { text: "Both A and B", correct: true },
        { text: "None of the above" },
      ],
    },
    {
      text: "Which ingredient used in Ayush Kwatha also acts on acidity?",
      responses: [
        { text: "Tulsi" },
        { text: "Jaggery" },
        { text: "Ginger", correct: true },
        { text: "Pepper" },
      ],
    },
    {
      text: "Minimum distance to be maintained between two persons is",
      responses: [
        { text: "2 Feet" },
        { text: "8 Feet" },
        { text: "6 Feet", correct: true },
        { text: "1 Feet" },
      ],
    },
    {
      text: "What is called “Vishvabeshaja”?",
      responses: [
        { text: "Ginger", correct: true  },
        { text: "Garlic"},
        { text: "Tulsi" },
        { text: "Pepper" },
      ],
    },
    {
      text: "How much of Cinnamon is used?",
      responses: [
        { text: "2 parts", correct: true },
        { text: "3 parts" },
        { text: "4 parts" },
        { text: "1 part" },
      ],
    },
    {
      text: "How many days can Kashya be taken ?",
      responses: [
        { text: "4-21 days", correct: true },
        { text: "30 days" },
        { text: "50 days" },
        { text: "None of the above" },
      ],
    },
  ],
};
var userResponseSkelaton = Array(quiz.questions.length).fill(null);
import download from "downloadjs";
import b64toArray from "base64-arraybuffer";
import { degrees, PDFDocument, StandardFonts, rgb, fontkit } from "pdf-lib";
import pdfString from "raw-loader!../assets/cert.txt";
import opensans from "../assets/OpenSans-SemiBold.ttf"
export default {
  data() {
    return {
      quiz: quiz,
      Qi: 0,
      userResponses: userResponseSkelaton,
      pdfBytes: "",
      ansChosen: false,
    };
  },
  filters: {
    charIndex: function (i) {
      return String.fromCharCode(65 + i);
    },
  },
  methods: {
    getX(start, end, fieldWidth, textWidth) {
      if (textWidth >= fieldWidth) {
        return start;
      } else {
        return start + (end - textWidth) / 2;
      }
    },
    selectOption(index) {
      this.ansChosen = true;
      this.$set(this.userResponses, this.Qi, index);
    },
    prev() {
      this.ansChosen = true;
      if (this.quiz.questions.length > 0) this.Qi--;
    },
    next() {
      this.ansChosen = false;
      if (this.Qi < this.quiz.questions.length) this.Qi++;
      console.log(this.Qi);
    },
    getScore() {
      var score = 0;
      for (let i = 0; i < this.userResponses.length; i++) {
        if (
          typeof this.quiz.questions[i].responses[this.userResponses[i]] !==
            "undefined" &&
          this.quiz.questions[i].responses[this.userResponses[i]].correct
        ) {
          score = score + 1;
        }
      }
      return score;

      //return this.userResponses.filter(function(val) { return val }).length;
    },
    async pdf() {
      //console.log(pdf);
      var pdf = pdfString;
      var existingPdfBytes = b64toArray.decode(pdf);
      //console.log(xx);
      const pdfDoc = await PDFDocument.load(existingPdfBytes);
      const helveticaFont = await pdfDoc.embedFont(StandardFonts.TimesRomanBold);

      // Get the first page of the document
      const pages = pdfDoc.getPages();
      const firstPage = pages[0];

      // Get the width and height of the first page
      const { width, height } = firstPage.getSize();
      var Nstart = width / 3 - 15;
      var Nend = Nstart * 1.5;
      var Nwidth = Nend;
      var Pstart = width / 8 - 15;
      var Pend = Pstart * 4.85;
      var Pwidth = Pend;
      // Draw a string of text diagonally across the first page
      firstPage.drawText(this.$store.state.name, {
        x: this.getX(
          Nstart,
          Nend,
          Nwidth,
          helveticaFont.widthOfTextAtSize(this.$store.state.name, 22)
        ),
        y: height / 2 + 3,
        size: 22,
        font: helveticaFont,
      });
      firstPage.drawText(this.$store.state.institute, {
        x: this.getX(
          Pstart,
          Pend,
          Pwidth,
          helveticaFont.widthOfTextAtSize(this.$store.state.institute, 22)
        ),
        y: height / 2 - 33,
        size: 22,
        font: helveticaFont,
      });
      firstPage.drawText(
        new Date().toJSON().slice(0, 10).split("-").reverse().join("/"),
        {
          x: width / 3.5 - 5,
          y: height / 3.5 + 5,
          size: 18,
          font: helveticaFont,
        }
      );
      // Serialize the PDFDocument to bytes (a Uint8Array)
      const pdfBytes = await pdfDoc.save();
      download(pdfBytes, "certificate.pdf", "application/pdf");
      this.$router.push({name:'socialmedia'})
    },
  },
  created(){
    if(this.$store.state.name == null || this.$store.state.name == ""){
      this.$router.push({name:"Login"});
      console.log(this.$store.state.name)
    }
  }
};
</script>

<style>
body {
  background: #cfd8dc;
  /* mocking native UI */
  cursor: default !important;
  /* remove text selection cursor */
}

.animated {
  -webkit-transition-duration: 0.15s;
  transition-duration: 0.15s;
}

.optionContainer .option {
  text-align: left;
  border-radius: 50px;
  padding: 9px 18px;
  margin-bottom: 12px;
  -webkit-transition: 0.3s;
  transition: 0.3s;
  cursor: pointer;
  background-color: rgba(0, 0, 0, 0.05);
  color: rgba(0, 0, 0, 0.85);
  border: transparent 1px solid;
}
.optionContainer .option.is-selected {
  border-color: rgba(248, 0, 0, 0.808);
  background-color: rgba(248, 0, 0, 0.808);
}
.optionContainer .option.is-correct {
  border-color: rgba(33, 241, 6, 0.808);
  background-color: rgba(33, 241, 6, 0.808);
}
.optionContainer .option.is-selected-wrong {
  border-color: rgba(33, 241, 6, 0.808);
    background-color: rgba(33, 241, 6, 0.808);
}
.optionContainer .option:hover {

}
.optionContainer .option:active {
  -webkit-transform: scaleX(0.9);
  transform: scaleX(0.9);
}

.button {
  border-radius: 5rem;
}
</style>
